/* if the shipping price in a crosssell widget returns some strange string value, the function returns true => free shipping,
 * to avoid errors in the frontend */

export const crossSellAccessorIsFreeShipping = (
  shippingPrice: string,
): boolean => {
  const num = Number.parseFloat(
    shippingPrice.replaceAll(' ', '').replace(',', '.'),
  )
  if (Number.isNaN(num)) {
    return true
  }

  return num === 0
}
